<template>
  <span class="link" @click="handleManualEntryToggle"> Enter Manually </span>
</template>

<script setup>
import { defineEmits, defineProps } from "vue";

const props = defineProps({
  isManualEntry: Boolean
});

const emit = defineEmits(["toggle-manual-entry"]);

function handleManualEntryToggle() {
  emit("toggle-manual-entry");
}
</script>

<style lang="scss" scoped></style>
